import React from "react"

import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"
import FieldTags from "../../tags"
import FieldTags_FormView from "./form-view"

export default function FieldTags_FormElementView(props: FieldFormElementViewProps) {

    const value = props.field.getViewValue(props.model)

    return (
        <FieldTags_FormView
            className           = {props.className}
            field               = {props.field as unknown as FieldTags}
            value               = {value}
            disabled            = {props.disabled}
            onChange            = {props.onChange}
            onImmediateChange   = {props.onChange}
        />
    )
}
